import { getGlobals } from "storyblok/api"
import {
  getAllPracticeAreaCategories,
  getAllPracticeAreaCategoriesPaths,
  getCategoryArchivePracticeAreas,
} from "storyblok/practiceAreas"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import ArchiveCard from "components/ArchiveCard"
import Meta from "components/Meta"
import { CardListSection } from "components/Archive/CardListSection"
import { cateogrySeoMeta } from "utilities/categorySeoMeta"
import { BLOG_ARTICLES_PER_PAGE } from "utilities/blogHelpers"

export default function PracticeAreaCategoryArchive({
  category,
  items,
  allItems,
  categories,
  perPage,
  total,
  currentPage,
  archiveOrder,
}) {

  const catMeta = cateogrySeoMeta[category.value]

  return (
    <>
      <Meta info={{ title: `${catMeta ? catMeta?.title : category.name}`, og_title: `${catMeta ? catMeta?.title : category.name}`, twitter_title: `${catMeta ? catMeta.title : category.name}`, description: catMeta?.meta, og_description: catMeta?.meta, twitter_description: catMeta?.meta }} />
      <main data-pagefind-ignore="all">
        <PageHeader
          blok={{
            type: "standard",
            heading: catMeta ? catMeta?.h1 : category.name,
            breadcrumbs: [{ text: "Practice Areas", href: "/practice-areas" }, { text: category.name }],
          }}
        />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/practice-areas"
          categoryLinkPrefix="/practice-areas/category/"
          currentTab={category}
          list={
            <CardListSection
              key={category.value}
              items={items}
              allItems={allItems}
              total={total}
              perPage={perPage}
              currentPage={currentPage}
              archiveOrder={archiveOrder}
              columns={4}
              category={category.value}
              Card={ArchiveCard}
            />
          }
        />
      </main>
    </>
  )
}

export async function getStaticProps({ params: { category } }) {
  const globals = await getGlobals()
  const categories = await getAllPracticeAreaCategories()
  const { items: allItems, total, archiveOrder } = await getCategoryArchivePracticeAreas({ category, allItems: true })
  const perPage = BLOG_ARTICLES_PER_PAGE

  return {
    props: {
      category: { name: category.replaceAll("-", " "), value: category },
      items: allItems.slice(0, perPage) ?? null,
      allItems: allItems ?? null,
      categories: categories ?? null,
      globals: globals ?? null,
      perPage,
      total,
      currentPage: 1,
      archiveOrder,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllPracticeAreaCategoriesPaths(),
    fallback: false,
  }
}
